var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main-div loading-screen"},[_c('div',{staticClass:"center absolute"},[_c('BrandIconLoading',{attrs:{"colorTriangle":"var(--dark-textcolor)","size":"calc(3rem + 2vmin)"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }